export default __webpack_public_path__ + "static/media/LAX-logo2.51b63379.png";